<template>
  <b-container fluid>
    <b-row class="row-sm" style="height: 100vh">
      <b-col class="rdcolors login-left">
        <img
          style="width: 10.8rem; height: 2.4rem"
          src="../assets/images/logo.png"
          alt="readycash logo"
        />
      </b-col>
      <b-col class="login-right">
        <b-row style="width: 100%">
          <b-col offset="2" cols="8">
            <h4 style="font-weight: 700" class="pb-2">
              Welcome to
              <span style="color: var(--primary); display: block"
                >ReadyCash Aggregator Portal</span
              >
            </h4>
            <p style="color: var(--gray-400); font-size: 1.125rem" class="pb-3">
              Enter your login details to access your account
            </p>
            <div class="invalid-feedback d-block">
              {{ error }}
            </div>
            <b-form @submit.prevent="submit">
              <div class="pb-3">
                <label>Agent ID</label>
                <b-form-input
                  :class="{ 'is-invalid': $v.agent_id.$error }"
                  type="text"
                  placeholder="Enter agent id"
                  v-model.trim="$v.agent_id.$model"
                  trim
                />
                <div class="invalid-feedback">
                  {{ $v.agent_id.$error ? "Agent Id is required" : "" }}
                </div>
              </div>

              <div class="pb-3">
                <label>Password</label>
                <b-form-input
                  :class="{ 'is-invalid': $v.password.$error }"
                  :type="inputType"
                  placeholder="Enter Password"
                  v-model.trim="$v.password.$model"
                  trim
                />
                <img
                  class="eye"
                  :class="{
                    'eye-mt': inputType == 'text',
                  }"
                  :src="require('./../assets/icons/eye-' + eyeState + '.svg')"
                  alt="Hidden"
                  @click="toggleEyeState"
                />
                <div class="invalid-feedback">
                  {{ $v.password.$error ? "Password is required" : "" }}
                </div>
                <div class="text-danger" style="font-size: 14px" v-if="expired">
                  Session expired. Please login again
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <router-link
                  to="/forgot-password"
                  class="text-primary py-3"
                  style="font-weight: 600"
                >
                  Forgot your password?
                </router-link>
              </div>
              <b-button
                :disabled="user.loading"
                type="submit"
                block
                variant="primary"
                >{{
                  user.loading ? "Loading..." : "Login to your account"
                }}</b-button
              >
            </b-form>
            <p
              style="
                padding-top: 2rem;
                color: var(--gray-600);
                text-align: center;
              "
            >
              Don’t have an aggregator account?<router-link
                style="font-weight: 600"
                to="/signup"
              >
                Sign up now</router-link
              >
            </p>
            <div
              style="
                background: hsla(349, 85%, 56%, 0.05);
                border-radius: 6px;
                margin-top: 3rem;
              "
              class="p-3"
            >
              <p
                class="text-primary"
                style="font-size: 0.875rem; margin-bottom: 0"
              >
                Please note
              </p>
              <p
                style="
                  color: var(--gray-600);
                  font-size: 0.8125rem;
                  margin-bottom: 0;
                "
              >
                Only aggregators can log into this portal. Aggregators are
                readycash agents that have agents registered under them.
              </p>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      agent_id: "",
      password: "",
      disabled: true,
      expired: false,
    };
  },
  validations: {
    agent_id: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    ...mapActions({
      login: "user/login",
    }),
    toggleEyeState() {
      this.$store.dispatch("toggleEyeState");
    },
    submit() {
      this.$store.state.eye.inputType = "password";
      this.$store.state.eye.eyeState = "hidden";
      this.$store.state.user.error = null;
      this.expired = false;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.login({
          agent_id: this.$data.agent_id,
          password: this.$data.password,
        }).then(() =>
          this.user.token ? this.$router.replace("dashboard") : null
        );
      }
    },
  },
  computed: mapState({
    user: (state) => state.user,
    error: (state) => state.user.error,
    inputType: (state) => state.eye.inputType,
    eyeState: (state) => state.eye.eyeState,
  }),
  created() {
    let previousUrl = this.$router.history._startLocation;
    if (
      window.localStorage.getItem("clickedLogout") === "false" &&
      previousUrl !== "/login" &&
      previousUrl.length > 1
    ) {
      this.expired = true;
    }
  },
  destroyed() {
    this.$store.state.user.error = null;
    this.expired = false;
  },
};
</script>

<style lang="scss">
.login-left {
  padding: 1.5rem;
  background: hsl(0, 100%, 98%);
}
@media screen and (max-width: 767px) {
  .row-sm {
    flex-direction: column;
  }
}
</style>
